import { render, staticRenderFns } from "./CTable.vue?vue&type=template&id=7ff20188&scoped=true&"
import script from "./CTable.vue?vue&type=script&lang=ts&"
export * from "./CTable.vue?vue&type=script&lang=ts&"
import style0 from "./CTable.vue?vue&type=style&index=0&id=7ff20188&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff20188",
  null
  
)

export default component.exports